import { lazy } from 'react';
import { RouteConfig } from 'react-router-config';

export const expenseRoutes = (): RouteConfig[] => [
  {
    path: '/expense',
    exact: true,
    name: '订单管理',
    component: lazy(() => import('@/presentation/pages/expense')),
    hideInMenu: true,
    whitelisted: true,
    pmWhitelisted: true,
  },
  {
    path: '/expense/order-details',
    name: '订单详情',
    component: lazy(() => import('@/presentation/pages/expense/order/details')),
    hideInMenu: true,
    whitelisted: true,
    pmWhitelisted: true,
  },
];

export default expenseRoutes;
